module.exports = __webpack_public_path__ + "media/img/uploads/atak-mil-product-thumb-01-6737c9de7bb7db80046908e4fa0233ba.png";